import React from 'react';

const isPreviewEnv = process.env.WEB_PREVIEW === 'true' || process.env.NODE_ENV === 'development';
const PREVIEW_COOKIE_NAME = 'X-Preview';
const code = isPreviewEnv
  ? `
window.addEventListener('DOMContentLoaded', (event) => {
    // [Control Cookie]
    console.log("[NuWebsitePreview: Loaded]");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const NEW_PREVIEW_URL = urlSearchParams.get("preview");
    const hasPreviewValueInURL = Boolean(NEW_PREVIEW_URL);
    const currentCookies = document.cookie.split(';').reduce((acc, curr) => {
      const [key, value] = curr.split('=');
      acc[key.trim()] = value;
      return acc;
    }, {});

    if(hasPreviewValueInURL) {
      document.cookie = "${PREVIEW_COOKIE_NAME}="+NEW_PREVIEW_URL+"; expires=" + new Date(new Date().getTime()+60*60*1000*24).toGMTString() + "; path=/";
      const isANewCookie = currentCookies["${PREVIEW_COOKIE_NAME}"] !== NEW_PREVIEW_URL;
      if(isANewCookie) {
        console.log("New preview, reloading...");
        window.location.href = window.location.href;
      }
    }

    // [Control Preview]
    if(window.location.host.includes('vercel.app')) {
      document.body.innerHTML = '';
      document.head.innerHTML = '';
      document.write('');
    }
  });
` : '';

export default function NuWebPreview() {
  return (
    <>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: code,
        }}
      />
    </>
  );
}
